import React from 'react';
import { Link } from "react-router-dom";

interface IProps {
    data?: Record<string, any>;
}

const LinkListWidget: React.FC<IProps> = ({ data }) => {

    return <div className="full-width row-to-column-start flex-wrap">

        {data?.map(linkList => {

            return <div className={linkList?.className || "column-start gap-sm  max-300   text-left"} >
                {linkList?.title ? <h2 style={{ fontSize: linkList?.titleFontSize || '16px', lineHeight: '20px', color: linkList?.titleColor || '#333' }}>{linkList?.title}</h2> : <></>}

                {linkList?.links?.map(linkValue => {

                    return linkValue?.type === 'external' ? <a style={{ maxWidth: linkValue?.maxWidth || '100%' }} tabIndex={0} href={linkValue?.url} target='_BLANK' className='row row-start gap-sm ' >
                        <p style={{ fontWeight: 'bold', color: linkList?.contentColor || '#333', fontSize: linkList?.contentFontSize || '14px' }}> {linkValue?.title}</p>
                    </a> : linkValue?.type === 'internal' ? <Link style={{ maxWidth: linkValue?.maxWidth || '100%' }} tabIndex={0} to={linkValue?.url} className='row-start  gap-xs column-start-mobile ' >
                        <p style={{ fontWeight: 'bold', color: linkList?.contentColor || '#333', fontSize: linkList?.contentFontSize || '14px' }}>{linkValue?.title}</p>
                    </Link> : <p style={{ width: '100%', fontWeight: 'bold', color: linkList?.contentColor || '#333', maxWidth: linkValue?.maxWidth || '100%', fontSize: linkList?.contentFontSize || '14px' }}>{linkValue?.title}</p>
                }


                )}




            </div>


        })}
    </div>

}



export default LinkListWidget;